export const LOGIN_ATTEMPT = 'LOGIN_ATTEMPT';
export const LOGIN_SUCCESSFULLY = 'LOGIN_SUCCESSFULLY';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN_STOP = 'LOGIN_STOP';

export const SET_CDN = 'SET_CDN';
export const SET_API = 'SET_API';
export const SET_MERCHANT_API = 'SET_MERCHANT_API';

export const SET_FIELDS = 'SET_FIELDS';

export const SET_ANALYTICS = 'SET_ANALYTICS';

export const SET_BLOCK_HEIGHT = 'SET_BLOCK_HEIGHT';

export const SET_PRIVACY_LINK = 'SET_PRIVACY_LINK';
export const SET_CONSENT_LINK = 'SET_CONSENT_LINK';
export const SET_COOKIE_LINK = 'SET_COOKIE_LINK';
export const SET_TOS_LINK = 'SET_TOS_LINK';

export const SHOW_CAPTCHA = 'SHOW_CAPTCHA';
export const REMOVE_RECAPTCHA = 'REMOVE_RECAPTCHA';
export const SET_RECAPTCHA = 'SET_RECAPTCHA';
export const HIDE_CAPTCHA = 'HIDE_CAPTCHA';

export const SHOW_CHINESE_CAPTCHA = 'SHOW_CHINESE_CAPTCHA';
export const HIDE_CHINESE_CAPTCHA = 'HIDE_CHINESE_CAPTCHA';
export const REMOVE_CHINESE_CAPTCHA = 'REMOVE_CHINESE_CAPTCHA';
export const SET_CHINESE_CAPTCHA = 'SET_CHINESE_CAPTCHA';

export const RESET_SET_TIMER = 'RESET_SET_TIMER';
export const RESET_ATTEMPT = 'RESET_ATTEMPT';
export const RESET_SUCCESSFULLY = 'RESET_SUCCESSFULLY';
export const RESET_FAILED = 'RESET_FAILED';

export const SET_ATTEMPT = 'SET_ATTEMPT';
export const SET_SUCCESSFULLY = 'SET_SUCCESSFULLY';
export const SET_FAILED = 'SET_FAILED';

export const REGISTRATION_ATTEMPT = 'REGISTRATION_ATTEMPT';
export const REGISTRATION_SUCCESSFULLY = 'REGISTRATION_SUCCESSFULLY';
export const REGISTRATION_FAILED = 'REGISTRATION_FAILED';
export const REGISTRATION_STOP = 'REGISTRATION_STOP';
export const REGISTRATION_RESET = 'REGISTRATION_RESET';

export const RESEND_CONFIRM_INIT = 'RESEND_CONFIRM_INIT';
export const RESEND_CONFIRM_CLEAR = 'RESEND_CONFIRM_CLEAR';
export const RESEND_CONFIRM_ATTEMPT = 'RESEND_CONFIRM_ATTEMPT';
export const RESEND_CONFIRM_SET_TIMER = 'RESEND_SET_TIMER';
export const RESEND_CONFIRM_SUCCESS = 'RESEND_CONFIRM_SUCCESS';
export const RESEND_CONFIRM_ERROR = 'RESEND_CONFIRM_ERROR';

export const ASK_ATTEMPT = 'ASK_ATTEMPT';
export const ASK_CONFIRM = 'ASK_CONFIRM';
export const ASK_SUCCESSFULLY = 'ASK_SUCCESSFULLY';
export const ASK_FAILED = 'ASK_FAILED';

export const CAPTCHA_REGISTER_FAILED = 'CAPTCHA_REGISTER_FAILED';
export const CAPTCHA_REGISTER_SUCCESSFULLY = 'CAPTCHA_REGISTER_SUCCESSFULLY';

export const SET_EMAIL = 'SET_EMAIL';
export const SET_USERNAME = 'SET_USERNAME';
export const SET_EMAIL_PROMO = 'SET_EMAIL_PROMO';

export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const IPIN_ATTEMPT = 'IPIN_ATTEMPT';
export const IPIN_VERIFICATION = 'IPIN_VERIFICATION';
export const IPIN_SUCCESSFULLY = 'IPIN_SUCCESSFULLY';
export const IPIN_FAILED = 'IPIN_FAILED';

export const SMS_ATTEMPT = 'SMS_ATTEMPT';
export const SMS_VERIFICATION = 'SMS_VERIFICATION';
export const SMS_SUCCESSFULLY = 'SMS_SUCCESSFULLY';
export const SMS_FAILED = 'SMS_FAILED';

export const SEARCH_AUTH_TYPE = 'SEARCH_AUTH_TYPE';
export const SET_DEVICE_TYPE = 'SET_DEVICE_TYPE';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_LOCALIZATION = 'SET_LOCALIZATION';
export const SET_VERSION = 'SET_VERSION';
export const SET_IS_OAUTH2 = 'SET_IS_OAUTH2';
export const NOT_IFRAME = 'NOT_IFRAME';

export const SET_SERVER_DATE = 'SET_SERVER_DATE';
export const SET_SERVER_IP = 'SET_SERVER_IP';
export const SET_SERVER_NAME = 'SET_SERVER_NAME';
export const SET_SERVER_GEO = 'SET_SERVER_GEO';

export const OTP_LOGIN_ATTEMPT = 'OTP_LOGIN_ATTEMPT';
export const OTP_LOGIN_SUCCESSFULLY = 'OTP_LOGIN_SUCCESSFULLY';
export const OTP_LOGIN_FAILED = 'OTP_LOGIN_FAILED';

export const OTP_RESEND_ATTEMPT = 'OTP_RESEND_ATTEMPT';
export const OTP_RESEND_FAILED = 'OTP_RESEND_FAILED';
export const OTP_RESEND_TIMER_TICK = 'OTP_RESEND_TIMER_TICK';

export const SOCIAL_PROVIDER_INFO = 'SOCIAL_PROVIDER_INFO';



// WEBPACK FOOTER //
// ./types/index.js